import React from 'react';
import { Shield, Eye, Heart, Sparkles } from 'lucide-react';
import { about, images } from '../../content';

const iconMap = {
  Shield,
  Eye,
  Heart,
  Sparkles
};

// Valores por defecto
const defaultAbout = {
  sectionLabel: "Nuestra historia",
  sectionTitle: "Más que una financiera,",
  sectionTitleHighlight: "tu aliado de confianza",
  description: "Somos una institución financiera que cree en las personas.",
  values: []
};

export const AboutSection = () => {
  // Obtener contenido con fallbacks
  const content = {
    sectionLabel: about?.sectionLabel || defaultAbout.sectionLabel,
    sectionTitle: about?.sectionTitle || defaultAbout.sectionTitle,
    sectionTitleHighlight: about?.sectionTitleHighlight || defaultAbout.sectionTitleHighlight,
    description: about?.description || defaultAbout.description,
    values: about?.values || defaultAbout.values
  };

  const aboutImage = images?.about || "/images/about-profesional.jpg";

  return (
    <section id="quienes-somos" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div className="space-y-8">
            <div>
              <span className="text-[#CFA935] font-semibold text-sm uppercase tracking-wider">
                {content.sectionLabel}
              </span>
              <h2 className="mt-3 text-3xl sm:text-4xl font-bold text-[#013C5D] leading-tight">
                {content.sectionTitle}{' '}
                <span className="text-[#CFA935]">{content.sectionTitleHighlight}</span>
              </h2>
            </div>

            <div className="space-y-4 text-gray-600 leading-relaxed">
              <p>{content.description}</p>
            </div>

            {/* Values - Larger icons */}
            {content.values.length > 0 && (
              <div className="grid grid-cols-2 gap-5 pt-4">
                {content.values.map((value, idx) => {
                  const Icon = iconMap[value.icon] || Shield;
                  return (
                    <div
                      key={value.id || idx}
                      className="flex items-center gap-4 bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl px-5 py-5 hover:shadow-lg transition-all duration-300 border border-gray-100"
                    >
                      <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#CFA935]/20 to-[#CFA935]/10 flex items-center justify-center shadow-sm">
                        <Icon className="w-8 h-8 text-[#CFA935]" />
                      </div>
                      <span className="font-semibold text-[#013C5D] text-lg">{value.name}</span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/* Visual */}
          <div className="relative">
            <div className="relative">
              {/* Main image */}
              <div className="rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src={aboutImage}
                  alt="Profesional de CONFIARÉ"
                  className="w-full h-[500px] object-cover"
                />
              </div>

              {/* Decorative element */}
              <div className="absolute -top-6 -right-6 w-24 h-24 bg-[#CFA935]/20 rounded-full blur-2xl" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
